import { Component, Fragment } from 'react';
import GameData from "../../mobx/GameData";
import { Button, Card, Dropdown, Modal } from "react-bootstrap";

import './LevelReviewDialog.scss';
import ApplicationState from "../../mobx/ApplicationState";

import { Col, Row, Container } from "react-bootstrap";

import GameplayStyle, { getGameplayStyleFromKey } from '../../data/GameplayStyle';
import NesGraphics from '../services/NesGraphics';

export default class LevelReviewDialog extends Component {

    tileCache = [];
    canvasList = [];
    previewImageList = [];
    constructor(props) {
        super(props);

        this.state = {
            gameTiles: JSON.parse(JSON.stringify(GameData.currentGame.tileData)),
            palettes: [
                GameData.currentGame.gamePaletteData.slice(0, 4),
                GameData.currentGame.gamePaletteData.slice(4, 8),
                GameData.currentGame.gamePaletteData.slice(8, 12),
                GameData.currentGame.gamePaletteData.slice(12, 16)
            ],
            levels: JSON.parse(JSON.stringify(GameData.currentGame.levels)).map((a, i) => { a.origIndex = i; return a;}),
            draggingIdx: null,
            draggingHoverIdx: null
        };        
        this.canvasList = GameData.currentGame.levels.map(() => { 
            const c = document.createElement('canvas')
            c.setAttribute('width', 448);
            c.setAttribute('height', 384);
            return c;
        });
    }

    async componentDidMount() {
        for (let i = 0; i < 16; ++i) {
            const img = await NesGraphics.convertMetaToBase64Image(
                GameData.currentGame.gameGraphicsData, 
                this.state.palettes[GameData.currentGame.tileData[i].palette],
                i, 
                {rawImage: false}
            );

            const image = document.createElement('img');
            image.src = img;
            this.tileCache.push(image);
        }
        for (let i = 0; i < GameData.currentGame.levels.length; i++) {
            this.generateLevelPreview(i);
        }

        this.forceUpdate();

    }

    shiftLevel(idx, whichWay) {
        const l1 = this.state.levels[idx];
        const l2 = this.state.levels[idx + whichWay];
        const levels = JSON.parse(JSON.stringify(this.state.levels))
        levels[idx] = l2;
        levels[idx + whichWay] = l1;
        this.setState({levels})
    }

    setLevelStyle(idx, style) {
        const l = this.state.levels
        l[idx].style = style;
        this.setState({levels: l})
    }

    async drawTile(c2d, tileId, tileIndex) {
        const x = (tileIndex % 14);
        const y = Math.floor(tileIndex / 14);
        const imgToCopy = this.tileCache[tileId]
        c2d.drawImage(imgToCopy, x*32, y*32, 32, 32);
        return;
    }

    levelDragStart(event, idx) {
        this.setState({draggingIdx: idx})
    }

    levelDragEnter(event, idx) {
        this.setState({draggingHoverIdx: idx})
    }

    levelDragEnd(event, idx) {
        const levels = JSON.parse(JSON.stringify(this.state.levels));
        if (this.state.draggingHoverIdx !== null) {
            levels.splice(this.state.draggingIdx, 1);
            levels.splice(this.state.draggingHoverIdx, 0, this.state.levels[this.state.draggingIdx]);
        }
        this.setState({draggingIdx: null, draggingHoverIdx: null, levels});
    }


    generateLevelPreview(lvl) {
        const level = this.state.levels[lvl],
            c2d = this.canvasList[lvl].getContext('2d')
        
        for (let i = 0; i < 14; ++i) {
            this.drawTile(c2d, level.borderTile, i);
            this.drawTile(c2d, level.borderTile, (11 * 14) + i);

            if (i < 12) {
                this.drawTile(c2d, level.borderTile, i*14);
                this.drawTile(c2d, level.borderTile, i*14 + 13);    
            }
        }

        for (let x = 0; x < 12; x++) {
            for (let y = 0; y < 10; y++) {
                this.drawTile(c2d, level.tiles[y*12+x], (x+1) + (y+1)*14)
            }
        }

        this.previewImageList[lvl] = this.canvasList[lvl].toDataURL('image/png');

    }

    saveChanges() {
        GameData.replaceCurrentGame({
            ...GameData.currentGame,
            levels: this.state.levels
        })
        ApplicationState.addAlert('success', 'Level order has been updated!');
        this.props.onClose();
    }

    render() {
        let levels = JSON.parse(JSON.stringify(this.state.levels));

        if (this.state.draggingHoverIdx !== null) {
            levels.splice(this.state.draggingIdx, 1);
            levels.splice(this.state.draggingHoverIdx, 0, this.state.levels[this.state.draggingIdx]);
        }
        return (
            <Modal show={true} fullscreen={true} onHide={this.props.onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Level Review</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="level-review-dialog">
                        <Container>
                            <Row>
                                <Col>
                                    <p className="mt-3">
                                        You can use this page to rearrange your levels, and validate their play styles.
                                    </p>
                                        
                                    <div className="mt-3">
                                        {levels.map((level, idx) => (
                                            <Fragment key={'level-tile-' + level.origIndex}>
                                                <Card 
                                                    draggable 
                                                    style={{
                                                        display: (idx <= GameData.currentGame.lastLevel) ? "inline-block": "none",
                                                    }} 
                                                    className={"level " + (this.state.draggingHoverIdx === idx ? 'hovered' : '')}
                                                    onDragStart={e => this.levelDragStart(e, idx) }
                                                    onDragEnter={e => this.levelDragEnter(e, idx) }
                                                    onDragEnd={e => this.levelDragEnd(e, idx) }
                                                >
                                                    <div className="button-bar">
                                                        <Button disabled={idx === 0} size="sm" className="left" variant="outline-secondary" onClick={() => this.shiftLevel(idx, -1)}>&lt;</Button>
                                                        <Button disabled={idx >= GameData.currentGame.lastLevel} size="sm" className="right" variant="outline-secondary" onClick={() => this.shiftLevel(idx, 1)}>&gt;</Button>
                                                    </div>
                                                    <Card.Body>
                                                        <img className="level-preview" alt={"level " + idx} src={this.previewImageList[level.origIndex]} draggable={false} onContextMenu={event => event.preventDefault()} />
                                                        <div className="mb-1">
                                                            <Dropdown className="gamestyle-dropdown">
                                                                <Dropdown.Toggle variant="outline-primary" size="sm">{getGameplayStyleFromKey(level.style)?.toLowerCase()?.replace(/_/g, ' ') || 'Game Default'}</Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item onClick={() => {this.setLevelStyle(idx, null) }}>Game Default</Dropdown.Item>
                                                                    {Object.keys(GameplayStyle).map((style, gpIdx) => {
                                                                        return <Dropdown.Item key={"gameplay-style-" + style} onClick={() => { this.setLevelStyle(idx, gpIdx) }}>{style.toLowerCase().replace(/_/g, ' ')}</Dropdown.Item>
                                                                    })}
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Fragment>
                                        ))}
                                    </div>
                                    <div className="button-footer-bar">
                                        <Button variant="primary" onClick={() => this.saveChanges()}>Save Changes</Button>
                                    </div>

                                </Col>
                            </Row>
                        </Container>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}